import { render } from "./SearchSuggestions.vue?vue&type=template&id=c912fe3a&scoped=true"
import script from "./SearchSuggestions.vue?vue&type=script&lang=js"
export * from "./SearchSuggestions.vue?vue&type=script&lang=js"

import "./SearchSuggestions.vue?vue&type=style&index=0&id=c912fe3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c912fe3a"]])

export default __exports__